import { render, staticRenderFns } from "./DietOptions.vue?vue&type=template&id=3018e34a&"
import script from "./DietOptions.vue?vue&type=script&lang=js&"
export * from "./DietOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports